import { useState, useEffect, useRef, useCallback } from "react";
import junior from "../assets/junior.png";
import practice from "../assets/practice.png";
import award from "../assets/award.jpg";
import prize from "../assets/prize.jpg";
import juniorzone from "../assets/juniorzone.jpg";

const PHOTOS = [
  { id: 1, src: "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=1200&q=85", title: "Tournament Finals 2024", sub: "District Championship", cat: "Tournament", year: "2024" },
  { id: 2, src: junior, title: "Training Session", sub: "Morning Practice", cat: "Training", year: "2024" },
  { id: 3, src: award, title: "Award Ceremony", sub: "State Level Awards", cat: "Awards", year: "2024" },
  { id: 4, src: award, title: "State Championship", sub: "GBA 2024", cat: "State", year: "2024" },
  { id: 5, src: practice, title: "Junior League", sub: "U15 Category", cat: "Junior", year: "2024" },
  { id: 6, src: "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=900&q=85", title: "West Zone 2024", sub: "Anand Hosted", cat: "West Zone", year: "2024" },
  { id: 7, src: practice, title: "Club Practice", sub: "Weekly Sessions", cat: "Training", year: "2024" },
  { id: 8, src: prize, title: "Prize Distribution", sub: "Champions Night", cat: "Awards", year: "2024" },
  { id: 9, src: award, title: "Opening Ceremony", sub: "Annual Tournament", cat: "Events", year: "2023" },
  { id: 10, src: practice, title: "U17 State Finals", sub: "Gold & Silver", cat: "State", year: "2023" },
  { id: 11, src: "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=900&q=85", title: "Coaching Workshop", sub: "BWF Certified Coaches", cat: "Training", year: "2023" },
  { id: 12, src: "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=900&q=85", title: "National Championship", sub: "3 Gold Medals", cat: "Tournament", year: "2023" },
  { id: 13, src: juniorzone, title: "Junior Awards Night", sub: "U13 · U15 Honours", cat: "Junior", year: "2023" },
  { id: 14, src: practice, title: "Doubles Finals", sub: "Men's Doubles · GBA 2023", cat: "Tournament", year: "2023" },
  { id: 15, src: juniorzone, title: "Annual Sports Day", sub: "Community Event", cat: "Events", year: "2023" },
  { id: 16, src: "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=900&q=85", title: "Felicitation Ceremony", sub: "State & National Achievers", cat: "Awards", year: "2022" },
  { id: 17, src: juniorzone, title: "West Zone Camp 2022", sub: "District Squad Selection", cat: "West Zone", year: "2022" },
  { id: 18, src: practice, title: "Founders Day Tournament", sub: "Inter-Club Championship", cat: "Events", year: "2022" },
];

const CATS = ["All", "Tournament", "Training", "Awards", "State", "Junior", "West Zone", "Events"];
const YEARS = ["All", "2024", "2023", "2022"];



/* ─────────────────────────────────────
   CSS INJECT
───────────────────────────────────── */
let _cssInjected = false;
const injectCSS = () => {
  if (_cssInjected || typeof document === "undefined") return;
  const el = document.createElement("style");
  el.innerHTML = CSS;
  document.head.appendChild(el);
  _cssInjected = true;
};

/* ─────────────────────────────────────
   SMOOTH SCROLL Y HOOK
───────────────────────────────────── */
const useScrollY = () => {
  const [sy, setSy] = useState(0);
  useEffect(() => {
    const fn = () => setSy(window.scrollY);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  return sy;
};

/* ─────────────────────────────────────
   HERO
───────────────────────────────────── */
const H_TILES = [
  [220, 290, 180, 250],
  [260, 180, 240, 200],
  [190, 250, 210, 270],
  [240, 190, 270, 180],
  [210, 260, 185, 245],
  [255, 200, 230, 190],
];

const Hero = ({ scrollY, onBrowse }) => {
  // parallax: wall drifts up slowly as you scroll
  const wallY = scrollY * 0.35;

  const BASE = Array.from({ length: 6 }, (_, ci) => ({
    id: ci,
    photos: Array.from({ length: 4 }, (__, ri) => PHOTOS[(ci * 3 + ri) % PHOTOS.length]),
    heights: H_TILES[ci],
  }));

  const renderCols = (prefix) =>
    BASE.map((col) => (
      <div key={`${prefix}-${col.id}`} className="gh-col">
        {col.photos.map((p, ti) => (
          <div key={ti} className="gh-tile" style={{ height: col.heights[ti] }}>
            <img src={p.src} alt="" loading={col.id < 2 ? "eager" : "lazy"} />
          </div>
        ))}
      </div>
    ));

  return (
    <div className="gh">
      {/* Scrolling mosaic wall */}
      <div
        className="gh-wall"
        style={{ transform: `translateY(${wallY}px)` }}
      >
        <div className="gh-wall-inner">
          {renderCols("a")}
          {renderCols("b")}
        </div>
      </div>

      {/* Overlays */}
      <div className="gh-grad" />
      <div className="gh-red-glow" />

      {/* Top-right corner badge */}
      <div className="gh-corner">
        <strong>{PHOTOS.length}+</strong>&nbsp;Photos · ADBA
      </div>

      {/* Centre content — parallax upward */}
      <div
        className="gh-body"
        style={{ transform: `translateY(calc(-24px + ${scrollY * -0.12}px))` }}
      >
        <div className="gh-tag">
          <span className="gh-tag-dot" />
          Anand District Badminton Association
        </div>

        <h1 className="gh-h1">
          <span className="w1">WALL OF</span>
          <span className="w2">MEMORIES</span>
        </h1>

        <div className="gh-sep" />

        {/* <p className="gh-sub">
          Every frame captures a champion's journey — tournaments,
          triumphs, and a community bound by badminton.
        </p> */}

        <div className="gh-stats">
          {[
            { n: PHOTOS.length, s: "+", l: "Photos" },
            { n: 3, s: "", l: "Years" },
            { n: 8, s: "", l: "Categories" },
            { n: 12, s: "+", l: "Events" },
          ].map((x, i) => (
            <div key={i} className="gh-stat">
              <span className="gh-stat-n">{x.n}<em>{x.s}</em></span>
              <span className="gh-stat-l">{x.l}</span>
            </div>
          ))}
        </div>

        <button className="gh-btn" onClick={onBrowse}>
          Browse Gallery
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      </div>

      {/* Scroll cue */}
      <div className="gh-scroll">
        <div className="gh-scroll-line" />
        Scroll
      </div>
    </div>
  );
};

/* ─────────────────────────────────────
   PARALLAX CARD (image moves on scroll)
───────────────────────────────────── */
const ParallaxCard = ({ photo, className, onClick, isFeatured }) => {
  const ref = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const el = ref.current;
    const imgEl = imgRef.current;
    if (!el || !imgEl) return;

    const onScroll = () => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = (vh / 2 - (rect.top + rect.height / 2)) / (vh / 2);
      const shift = progress * 18;
      imgEl.style.transform = `translateY(${shift}px)`;
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      ref={ref}
      className={`g-card ${className || ""} ${isFeatured ? "featured" : ""}`}
      onClick={onClick}
    >
      <div className="g-card-img" ref={imgRef}>
        <img src={photo.src} alt={photo.title} loading="lazy" />
      </div>
      <span className="g-card-year">{photo.year}</span>
      <div className="g-card-zoom">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
          <circle cx="11" cy="11" r="7" />
          <line x1="16.5" y1="16.5" x2="22" y2="22" />
          <line x1="8" y1="11" x2="14" y2="11" />
          <line x1="11" y1="8" x2="11" y2="14" />
        </svg>
      </div>
      <div className="g-card-over">
        <span className="g-card-cat">{photo.cat}</span>
        <div className="g-card-title">{photo.title}</div>
        <div className="g-card-sub">{photo.sub}</div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────
   LIGHTBOX
───────────────────────────────────── */
const Lightbox = ({ photos, idx, onClose, onPrev, onNext, onGoto }) => {
  const p = photos[idx];
  const stripRef = useRef(null);

  useEffect(() => {
    stripRef.current?.children[idx]?.scrollIntoView({ behavior: "smooth", inline: "center" });
  }, [idx]);

  return (
    <div className="g-lb" onClick={onClose}>
      <div className="g-lb-top" onClick={e => e.stopPropagation()}>
        <div className="g-lb-info">
          <span className="g-lb-cat">{p.cat}</span>
          <div className="g-lb-title">{p.title}</div>
          <div className="g-lb-sub">{p.sub} · {p.year}</div>
        </div>
        <button className="g-lb-x" onClick={onClose}>✕</button>
      </div>

      <div className="g-lb-stage" onClick={e => e.stopPropagation()}>
        <img key={idx} src={p.src} alt={p.title} className="g-lb-img" />
        <button className="g-lb-nav g-lb-prev" onClick={e => { e.stopPropagation(); onPrev(); }}>‹</button>
        <button className="g-lb-nav g-lb-next" onClick={e => { e.stopPropagation(); onNext(); }}>›</button>
        <div className="g-lb-ctr">{String(idx + 1).padStart(2, "0")} / {String(photos.length).padStart(2, "0")}</div>
      </div>

      <div className="g-lb-strip" ref={stripRef} onClick={e => e.stopPropagation()}>
        {photos.map((ph, i) => (
          <div key={ph.id} className={`g-lb-thumb ${i === idx ? "on" : ""}`} onClick={() => onGoto(i)}>
            <img src={ph.src} alt={ph.title} loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
};

/* ─────────────────────────────────────
   GALLERY PAGE
───────────────────────────────────── */
const GalleryPage = () => {
  injectCSS();

  const scrollY = useScrollY();
  const barRef = useRef(null);
  const [cat, setCat] = useState("All");
  const [year, setYear] = useState("All");
  const [lb, setLb] = useState(null);

  const filtered = PHOTOS.filter(p =>
    (cat === "All" || p.cat === cat) &&
    (year === "All" || p.year === year)
  );

  const scrollToBar = () => barRef.current?.scrollIntoView({ behavior: "smooth" });
  const openLb = useCallback(i => setLb(i), []);
  const closeLb = useCallback(() => setLb(null), []);
  const prevLb = useCallback(() => setLb(v => (v - 1 + filtered.length) % filtered.length), [filtered.length]);
  const nextLb = useCallback(() => setLb(v => (v + 1) % filtered.length), [filtered.length]);
  const gotoLb = useCallback(i => setLb(i), []);

  useEffect(() => {
    const fn = e => {
      if (lb === null) return;
      if (e.key === "Escape") closeLb();
      if (e.key === "ArrowLeft") prevLb();
      if (e.key === "ArrowRight") nextLb();
    };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [lb, closeLb, prevLb, nextLb]);

  useEffect(() => { setLb(null); }, [cat, year]);

  // split into featured (first) and rest
  const [feat, ...rest] = filtered;

  return (
    <>
      {/* HERO */}
      <Hero scrollY={scrollY} onBrowse={scrollToBar} />

      {/* SECTION HEADER */}
      <div className="g-header" ref={barRef}>
        <div className="g-header-left">
          <div className="g-header-bar" />
          <div className="g-header-title">PHOTO <span>GALLERY</span></div>
        </div>
        <div className="g-header-right">
          <strong>{filtered.length}</strong> photos from ADBA events,<br />
          tournaments &amp; training sessions.
        </div>
      </div>

      {/* FILTER BAR */}
      <div className="gf-bar">
        <div className="gf-inner">
          <div className="gf-cats">
            {CATS.map(c => (
              <button key={c} className={`gf-cat ${cat === c ? "on" : ""}`} onClick={() => setCat(c)}>{c}</button>
            ))}
          </div>
          <div className="gf-sep" />
          <div className="gf-years">
            {YEARS.map(y => (
              <button key={y} className={`gf-year ${year === y ? "on" : ""}`} onClick={() => setYear(y)}>
                {y === "All" ? "All Years" : y}
              </button>
            ))}
          </div>
          <span className="gf-count">{filtered.length} Photos</span>
        </div>
      </div>

      {/* GALLERY BODY */}
      <div className="g-body">
        {filtered.length === 0 ? (
          <div className="g-empty">
            <div style={{ fontSize: 52, opacity: .3, marginBottom: 12 }}>🏸</div>
            <div style={{ fontFamily: "var(--fu)", fontSize: 15, fontWeight: 300 }}>No photos match this filter.</div>
          </div>
        ) : (
          <>
            {/* Featured row */}
            {feat && (
              <div className="g-featured">
                <ParallaxCard photo={feat} className="big" isFeatured onClick={() => openLb(0)} />
                <div className="g-featured-right">
                  {filtered.slice(1, 3).map((p, i) => (
                    <ParallaxCard key={p.id} photo={p} onClick={() => openLb(i + 1)} />
                  ))}
                </div>
              </div>
            )}

            {/* Regular 3-col grid */}
            {filtered.length > 3 && (
              <div className="g-grid">
                {filtered.slice(3).map((photo, i) => (
                  <ParallaxCard
                    key={`${photo.id}-${cat}-${year}`}
                    photo={photo}
                    onClick={() => openLb(i + 3)}
                    style={{ animationDelay: `${Math.min(i * 0.05, 0.4)}s` }}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {/* PAGE FOOTER */}
      <div className="g-foot">
        <span className="g-foot-txt">
          Showing <strong>{filtered.length}</strong> of <strong>{PHOTOS.length}</strong> photos · ADBA Archive
        </span>
      </div>

      {/* LIGHTBOX */}
      {lb !== null && (
        <Lightbox
          photos={filtered}
          idx={lb}
          onClose={closeLb}
          onPrev={prevLb}
          onNext={nextLb}
          onGoto={gotoLb}
        />
      )}
    </>
  );
};

export default GalleryPage;